// Copyright (c) 2019 Deere & Company

import actions from '../../action-list';
import {mapFormValidation} from '../services/claim-validation-helper';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {validAmountOfUse} from '../../shared/services/claim-shared-helper';

export const updateResponsibleAccountsDropDown = (accountId, dealerCollection, pin) =>

    dispatch => {

        dispatch({
            accountId,
            dealerCollection,
            type: actions.UPDATE_CLAIM_INCENTIVE_RESPONSIBLE_ACCOUNTS
        });

        if (accountId) {

            readLaborTypes(accountId, pin, true)(dispatch);

        }

    };

export const updateIncentiveClaimInputOnBlur = (property, value, claim) => ({
    property,
    type: actions.UPDATE_CLAIM_INCENTIVE_FORM_VALIDATION,
    validity: mapFormValidation(property, value, claim)
});

export const resetIncentiveClaim = () => ({
    type: actions.RESET_CLAIM_INCENTIVE
});

export const updateIncentiveClaimWorkOrderOne = workOrder => ({
    type: actions.UPDATE_CLAIM_INCENTIVE_WORK_ORDER_ONE,
    workOrder
});

export const updateIncentiveClaimWorkOrderTwo = workOrder => ({
    type: actions.UPDATE_CLAIM_INCENTIVE_WORK_ORDER_TWO,
    workOrder
});

export const updateIncentiveCustomerName = customerName => ({
    customerName,
    type: actions.UPDATE_CLAIM_INCENTIVE_CUSTOMER_NAME
});

export const updateIncentiveEmail = email => ({
    email,
    type: actions.UPDATE_CLAIM_INCENTIVE_EMAIL
});

export const updateIncentiveClaimRepairDate = date => ({
    date,
    type: actions.UPDATE_CLAIM_INCENTIVE_REPAIR_DATE
});

export const updateIncentiveClaimUseAmount = (amount, index) => ({
    amount: validAmountOfUse(amount),
    index,
    type: actions.UPDATE_CLAIM_INCENTIVE_USE_AMOUNT
});

export const updateIncentiveClaimFailurePart = partNumber => ({
    partNumber,
    type: actions.UPDATE_CLAIM_INCENTIVE_FAILURE_PART
});

export const updateIncentiveClaimRepairNumber = repairNumber => ({
    repairNumber,
    type: actions.UPDATE_CLAIM_INCENTIVE_REPAIR_NUMBER
});

export const updateIncentiveClaimUnitDropDown = (key, unitCollection) => ({
    key,
    type: actions.UPDATE_CLAIM_INCENTIVE_USE_AMOUNT_UNIT,
    unitCollection
});

export const updateIncentiveClaimPin = pin => ({
    pin,
    type: actions.UPDATE_CLAIM_INCENTIVE_PIN
});

export const updateSelectedProgramDropDown = (programName, collection) => ({
    collection,
    programName,
    property: 'selectedProgram',
    type: actions.UPDATE_CLAIM_INCENTIVE_SELECTED_PROGRAM
});



// WEBPACK FOOTER //
// ./src/claim/incentive/action-creators/claim-incentive-details.js